export type DominantHandType = 'left_handed' | 'right_handed' | 'unknown';

export const DominantHandMaps = new Map<DominantHandType, string>([
    ['left_handed', '左利き'],
    ['right_handed', '右利き'],
    ['unknown', '未設定'],
]);

export const DominantHands = Object.fromEntries<string>(DominantHandMaps);
